import PropTypes from 'prop-types';
import TituloSessao from '../TituloSessao';
import { Fragment } from 'react';
import { limiteCaracteres } from '../../config/limiteCaracteres';

const BlocoEItensFormularioAcompanhamento = ({ blocoPerguntas, opcoesRespostas, respondeItem }) => {

    console.log('### Iniciando BlocoEItensFormularioAcompanhamento ###');

    const mapaClasseBotaoResposta = {
        'SIM': 'btn-outline-success',
        'NÃO': 'btn-outline-danger',
        'PARCIAL': 'btn-outline-danger',
        'N.A': 'btn-outline-secondary'
    };

    return (

        <div>
            <TituloSessao titulo={`${blocoPerguntas.blocoId} - ${blocoPerguntas.bloco}`} barraDecorativa={false} />
            <div className="d-flex flex-column div-com-borda p-3 gap-2">
                {blocoPerguntas.itens && blocoPerguntas.itens.map((item) => (
                    <div key={item.modeloId} className="card shadow-sm">
                        <div className="card-header bg-white d-flex align-items-center gap-2 py-3">
                            <span className="badge bg-secondary">{blocoPerguntas.blocoId}.{item.modeloCodigo}</span>
                            <span className="fw-semibold text-dark">{item.modeloDescricao}</span>
                        </div>
                        <div className="card-body pb-2">
                            <div className="d-flex flex-wrap gap-2 mb-3">
                                {opcoesRespostas && opcoesRespostas.map((resposta) => {
                                    const idInputResposta = `respItemId${item.modeloId}RespId${resposta.id}`
                                    return (
                                        <Fragment key={resposta.id}>
                                            <input
                                                className="btn-check"
                                                id={idInputResposta}
                                                type="radio"
                                                name={`respItemId_${item.modeloId}`}
                                                value={resposta.id}
                                                onChange={(e) => respondeItem(item.modeloId, 'respostaId', Number(e.target.value))}
                                                autoComplete="off"
                                            />
                                            <label
                                                className={`btn btn-sm ${mapaClasseBotaoResposta[resposta.resposta]}`}
                                                htmlFor={idInputResposta}
                                            >
                                                {resposta.resposta}
                                            </label>
                                        </Fragment>
                                    )
                                })}
                            </div>
                            <input
                                className="form-control form-control-sm"
                                id={item.modeloId}
                                name="observacao"
                                placeholder="Observação (requerida para NÃO e PARCIAL) ..."
                                onBlur={(e) => respondeItem(item.modeloId, 'observacao', e.target.value)}
                                maxLength={limiteCaracteres.RELAT_ACOMP_OBS_ITEM}
                            />
                        </div>
                        <div className="card-footer bg-white text-end py-2">
                            <small className="text-muted">{blocoPerguntas.itens.indexOf(item) + 1} de {blocoPerguntas.itens.length} perguntas</small>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BlocoEItensFormularioAcompanhamento;

BlocoEItensFormularioAcompanhamento.propTypes = {
    blocoPerguntas: PropTypes.object.isRequired,
    opcoesRespostas: PropTypes.arrayOf(PropTypes.object).isRequired,
    respondeItem: PropTypes.func.isRequired
};